module.exports = function anonymous(it
/*``*/) {
var out='<div class="'+( it.container)+'"> <div pagination></div> <div sentence></div> <div class="'+( it.pane)+'"> <div attributes></div> <div svg class="'+( it.svg)+'"></div> </div></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./lib/template.dot
// module id = 19
// module chunks = 0